"use strict";
import { CsrfHeader } from "./accounts_payable/data/types/Pb";
import { csrfToken } from "./csrf_token";
export function channelAuthorizationWithCsrf() {
  const headers = {};
  Object.defineProperty(headers, CsrfHeader.CsrfHeaderToken, {
    enumerable: true,
    get: () => {
      var _a;
      return (_a = csrfToken()) != null ? _a : "";
    }
  });
  return {
    transport: "ajax",
    endpoint: "/pusher/auth",
    headers
  };
}
